/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable import/prefer-default-export */
import './public-path'
import './environment'
import './assets/styles/main.scss'
// eslint-disable-next-line import/no-unresolved
import 'vuetify/styles'
import 'regenerator-runtime/runtime'
// eslint-disable-next-line import/no-unresolved,import/no-extraneous-dependencies
import '@mdi/font/css/materialdesignicons.css'

import {
  createApp, h, ref
} from 'vue'

import appWrapperHook from '@src/utilities/appWrapper'
import HighchartsVue from 'highcharts-vue'
import PlainLayout from '@src/layouts/PlainLayout.vue'
import { initSentryOnce } from '@src/plugins/sentry'
import _get from 'lodash/get'
import { createVuetify } from 'vuetify'
import TextClamp from 'vue3-text-clamp'
import OneSignalVue from 'onesignal-vue-3'
import { realmSettingsKey } from '@src/realmSettingKey.type'
import { createPinia } from 'pinia'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueSnip from './directives/snip'
import App from './App.vue'
import i18n, { initLanguage } from './plugins/i18n'
import { createRouterForVueNativeMode } from './router'
import getVuetifyOpts from './plugins/vuetify/vuetify'
import AnalyticsPlugin, { IAnalyticsPluginOptions } from './plugins/analytics'
import { initAuth } from './utilities/auth'
import periodicVersionCheck from './periodicVersionCheck'
import { realmSettingsApi } from './api/apiModuleInstances'
import { BeforeInstallPromptEvent } from './types/beforeInstallPrompt.types'

async function init() {
  let beforeInstallPromptEvent: BeforeInstallPromptEvent | undefined
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    beforeInstallPromptEvent = e as BeforeInstallPromptEvent
  })

  const { data: realmSettings } = await realmSettingsApi.cached.get()

  const vuetify = createVuetify(getVuetifyOpts())

  const primaryColor = _get(realmSettings, 'white_labelling.primary', '#432CA0')
  const { theme } = vuetify
  const currentThemeName = theme.global.name.value
  theme.themes.value[currentThemeName].colors.primary = primaryColor

  await initAuth(realmSettings.auth.cookie_same_site_none)
  await initLanguage()

  const router = createRouterForVueNativeMode(realmSettings)

  const analyticsOptions: IAnalyticsPluginOptions = {
    getTrackingState: () => router.currentRoute.value?.name as string || '',
    debugMode: /debug-tracking/.test(window.location.search)
  }

  const pinia = createPinia()

  const app = createApp({
    render: () => h(App, {
      beforeInstallPromptEvent,
      realmSettings
    })
  })

  initSentryOnce(app, router)

  app.use(pinia)
  app.use(router)
  app.use(i18n)
  app.use(vuetify)
  app.use(HighchartsVue)
  app.use(AnalyticsPlugin, analyticsOptions)
  app.use(VueSnip)
  app.use(TextClamp)
  app.use(OneSignalVue)
  app.provide(realmSettingsKey, ref(realmSettings))

  app.component('PlainLayout', PlainLayout)

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    app.config.devtools = true
  }

  periodicVersionCheck()

  app.mount('#app')

  appWrapperHook('appIsLoaded')
}

init()
